<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'awaitingInvoiceItem',
    props: {
        items: Object,
        po: String,
        permission: String,
    },
    setup() {},
    data() {
        return {
            selectedPO: null,
            renderComponent: true,
        }
    },
    methods: {
        onBeforeShow(evt) {
            console.log(evt);
        },
        onHide(evt) {
            console.log(evt)
        },
        formatPrice(p) {
            return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(p);
        },
        formatSubTotal(qty, price, uom) {
            if (uom == "MFT" || uom == "FT") {
                return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((qty/1000)*price);
            }
            return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(qty*price);
        },
        returnItem({ evt, ...newInfo }) { 
            if (parseInt(this.permission) < 2 || this.hasConsignmentReturnPermission != "2") {
                this.$store.dispatch('message/sendMessage', {message: `You must have Return permissions enabled in order to use this functionality`, type:'negative', position: 'bottom', icon: 'fa fa-check'}, {root:true});
                return;
            }
            try {
                var i = evt.srcElement.firstChild.outerText != undefined ? evt.srcElement.firstChild.outerText : evt.srcElement.innerText;
                var po = this.$refs[i][0].attributes['data-po'].nodeValue
            }catch(e) {
                
                this.$store.dispatch('message/sendMessage', {message: `Return Item Selection Error - ${e}`, type:'negative', position: 'bottom', icon: 'fa fa-check'}, {root:true});
                return;
            }

            this.$store.commit('consignment/setReturnItem', i)
            this.$store.commit('consignment/setReturnPO', po)

        },
        toggleBillPO({ evt, ...newInfo }) {
            if (parseInt(this.permission) < 2 || !this.hasConsignmentBillingPermission) {
                return;
            }
                
            let po = evt.srcElement.firstChild.outerText != undefined ? evt.srcElement.firstChild.outerText : evt.srcElement.innerText;
            this.$store.commit('consignment/setBillPO', po.trim().toUpperCase());
        },
        toggleBillPOMouse(po) {
            if (parseInt(this.permission) < 2 || !this.hasConsignmentBillingPermission) {
                return;
            }
            this.$store.commit('consignment/setBillPO', po.trim().toUpperCase());
        },
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            this.$nextTick(() => {
            // Add the component back in
            this.renderComponent = true;
            });
        }
    },
    computed: {
        poTotal() {
            let t = 0;
            this.items.forEach(i => {
                if (i.quantityUnitOfMeasure == "MFT" || i.quantityUnitOfMeasure == "FT") {
                    t = t + (parseInt(i.quantityUsed)/1000) * i.price;
                } else {
                    t = t + parseInt(i.quantityUsed) * i.price;
                }
            });

            return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(t);
        },
        billPO() {
            return this.$store.getters['consignment/billPO']
        },
        hasConsignmentReturnPermission() {
            return this.$store.getters['auth/hasConsignmentReturnPermission']
        },
        hasConsignmentBillingPermission() {
            return this.$store.getters['auth/hasConsignmentBillingPermission']
        }
    }
})
</script>

<template>
    <q-expansion-item :expand-icon-class="[billPO.includes(po.trim().toUpperCase()) ? 'expandIconWCWSelected' : 'wcwBlue expandIconWCW']" v-bind:class="[billPO.includes(po.trim().toUpperCase()) ? 'selectedInvoice':'']">
        <template v-slot:header>
                <q-item-section>
                    <div class="row" v-touch-hold.touch="toggleBillPO" @mousedown.="toggleBillPOMouse(po)">
                        <div class="col-12">
                            <h2 style="line-height: 1.5em;">{{po}} </h2>
                            <span @touchstart.stop @mousedown.stop class="invoicePrice">${{poTotal}}<span>({{items.length}}<span v-if="items.length>1">items</span><span v-else>item</span>)</span></span>
                        </div>
                    </div>
                </q-item-section>       
        </template>

        <template v-slot:default>

            <div class="invoiceView" v-for="(item, idx) in items" :key="idx">
                <div class="row">
                    <div class="col-8">
                        <span class="returnHitBox" :ref="item.itemNumber" :data-po="po" v-touch-hold.mouse="returnItem">
                            <h3 class="wcwH block">{{item.itemNumber}}</h3>
                        </span>
                        <br/>
                        <p @touchstart.stop @mousedown.stop class="invoiceProductDescription">{{item.description}}</p>
                        <p @touchstart.stop @mousedown.stop class="invoiceProductDescription"><strong>Used: </strong>{{item.usedDate}}</p>
                    </div>
                    <div class="col-2" @touchstart.stop @mousedown.stop>
                        <span class="invoiceQuantity">Quantity:<span class="q-ml-xs">{{parseInt(item.quantityUsed)}}</span></span>
                        <span class="invoiceProductPrice">${{formatPrice(item.price)}} {{item.quantityUnitOfMeasure}}</span>
                        <span class="invoiceSubTotal">Subtotal:<span>${{formatSubTotal(parseInt(item.quantityUsed), item.price, item.quantityUnitOfMeasure)}}</span></span>
                    </div>
                </div>	
            </div>

        </template>


    </q-expansion-item>
    <div class="mobileDiv"></div>
      
</template>

<style>
.expandIconWCW i{font-size: 45px !important; padding-right: 0px;}
.expandIconWCWSelected i{font-size: 45px !important; padding-right: 0px; color: white;}
</style>

<style scoped>
    .returnHitBox{position: absolute; display: block; height: 60px; width: 100%;}
</style>